<template>
  <div id="app">
    <div ref="contentRef" :style="{height: showTabBar ? 'calc(100vh - 52px - env(safe-area-inset-bottom))' : '100%'}">
      <router-view/>
    </div>
    <div id="tabBar" ref="tabBarRef" v-if="showTabBar">
      <router-link :to="{path:'/home',query:{ token: this.$route.query.token }}"><span class="icon home"></span><span>首页</span></router-link>
      <router-link :to="{path:'/learn',query:{ token: this.$route.query.token }}"><span class="icon learn"></span><span>易经课堂</span></router-link>
      <router-link :to="{path:'/shop',query:{ token: this.$route.query.token }}"><span class="icon shop"></span><span>吉品兑换</span></router-link>
      <router-link :to="{path:'/user',query:{ token: this.$route.query.token }}"><span class="icon user"></span><span>我的</span></router-link>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import DFZHJsBridge from './utils/jsBridge'
import rx from './utils/rx'
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      showTabBar: false,
      isRouterAlive: true,
      selectedTab: 'home',
      tabs: [{
        label: '首页',
        value: 'home'
      }, {
        label: '在线学习',
        value: 'learn'
      }, {
        label: '吉品兑换',
        value: 'shop'
      }, {
        label: '我的',
        value: 'user'
      }]
    }
  },
  watch: {
    $route (to, from) {
      console.log(to)
      this.showTabBar = (to.path === '/home' || to.path === '/learn' || to.path === '/shop' || to.path === '/user') &&
        to.query.platform !== 'mini'
    }
  },
  mounted () {
    this.init()
    if (this.$route.query && this.$route.query.token) {
      console.log('app token=' + this.$route.query.token)
      this.$store.commit('setInfo', { token: this.$route.query.token })
    }
  },
  methods: {
    init () {
      if (DFZHJsBridge.disabled) {
        rx.setCb(() => { // http 402  403
          wx.miniProgram.redirectTo({ url: '/pages/index/index' })
          wx.miniProgram.postMessage({ data: 'logout' })
        })
      } else {
        if (!Vue.prototype.$dfzhJsBridge) {
          Vue.prototype.$dfzhJsBridge = DFZHJsBridge.createNew()
          Vue.prototype.$dfzhJsBridge.init()
          console.log('app mounted set cb')
          rx.setCb(() => {
            console.log('app get cb in mounted')
            Vue.prototype.$dfzhJsBridge.goLogout()
          })
        }
      }
    },
    onTabClick (value) {
      console.log(value)
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }

  }
}
</script>

<style lang="stylus">
#app
  font-family 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
  color #9D9D9D
  position relative
  font-size 12px
  height 100vh
  width 100%

#tabBar
  position fixed
  width 100%
  height calc(52px + constant(safe-area-inset-bottom))
  height calc(52px + env(safe-area-inset-bottom))
  bottom 0
  left 0
  box-sizing border-box
  box-shadow 0px -1px 0px 0px rgba(207,207,207,0.5)
  background-color #fff
  z-index 10
  padding-top 6px
  a
    font-size 10px
    color #9D9D9D
    display inline-block
    width 25%
    span
      width 100%
      display inline-block
      font-weight bold
    .icon
      height 28px
      margin-bottom 1px
    .icon.home
      background url("~@/assets/images/icons/icon-home-normal.png") no-repeat center
      background-size 28px 28px
    .icon.learn
      background url("~@/assets/images/icons/icon-class-normal.png") no-repeat center
      background-size 28px 28px
    .icon.shop
      background url("~@/assets/images/icons/icon-change-normal.png") no-repeat center
      background-size 28px 28px
    .icon.user
      background url("~@/assets/images/icons/icon-mine-normal.png") no-repeat center
      background-size 28px 28px
    &.router-link-exact-active
      color #662C85
      .icon.home
        background url("~@/assets/images/icons/icon-home-selected.png") no-repeat center
        background-size 28px 28px
      .icon.learn
        background url("~@/assets/images/icons/icon-class-selected.png") no-repeat center
        background-size 28px 28px
      .icon.shop
        background url("~@/assets/images/icons/icon-change-selected.png") no-repeat center
        background-size 28px 28px
      .icon.user
        background url("~@/assets/images/icons/icon-mine-selected.png") no-repeat center
        background-size 28px 28px
</style>
